(function () {
    "use strict";

    angular.module("app").factory("PersonCheckDialogContext", PersonCheckDialogContextFactory);

    PersonCheckDialogContextFactory.$inject = ["$q", "$filter", "settingsService", "habilBootbox",];
    function PersonCheckDialogContextFactory($q, $filter, settingsService, habilBootbox) {
        const translate = $filter("habilTranslation");
        const storage = {
            person: null,
            deferred: null,
        };

        return {
            openDialog,
            getPerson: () => storage.person,
            discard: discard,
            submit,
        };

        function openDialog(person) {
            storage.deferred = $q.defer();

            person.IsHandling = true;
            // Create a copy of the person to make it possible to discard changes
            storage.person = { ...person };

            habilBootbox.customDialog({
                onEscape: discard,
                title: translate("AssistanceIn_SecurityCheckResultDialog_Title"),
                templateUrl: `${settingsService.applicationPath}AssistanceIn/PersonCheckDialog`,
            });

            return storage.deferred.promise;
        }

        function submit() {
            storage.deferred.resolve(storage.person);

            closeDialog();
        }

        function discard() {
            storage.deferred.reject("Discard");

            closeDialog();
        }

        function closeDialog() {
            storage.person = null;
            habilBootbox.hideAll();
        }
    }
})();
